import React, { useEffect, useState } from "react";
import { Panel, Field } from "@/pages/admin/shared";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Save, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/pages/admin/api";

export default function FooterEditor() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/site-content").then((r) => setData(r.data.footer || {})); }, []);
  if (!data) return <div className="text-sm text-muted-foreground">Loading…</div>;

  const set = (k, v) => setData({ ...data, [k]: v });

  const setLink = (kind, idx, key, value) => {
    const next = [...(data[kind] || [])];
    next[idx] = { ...next[idx], [key]: value };
    set(kind, next);
  };
  const addLink = (kind) => set(kind, [...(data[kind] || []), { label: "", url: "" }]);
  const delLink = (kind, idx) => set(kind, (data[kind] || []).filter((_, i) => i !== idx));

  const save = async () => {
    setSaving(true);
    try { await api.put("/site-content", { footer: data }); toast.success("Footer updated"); }
    catch { toast.error("Save failed"); }
    finally { setSaving(false); }
  };

  const LinksBlock = ({ title, kind }) => (
    <Panel
      title={title}
      actions={<Button variant="outline" onClick={() => addLink(kind)} className="rounded-xl"><Plus size={14} className="mr-1" /> Add link</Button>}
    >
      <div className="space-y-3">
        {(data[kind] || []).map((l, i) => (
          <div key={i} className="grid md:grid-cols-[1fr_2fr_36px] gap-3 items-end rounded-xl border border-border p-3">
            <Field label="Label"><Input value={l.label} onChange={(e) => setLink(kind, i, "label", e.target.value)} /></Field>
            <Field label="URL"><Input value={l.url} onChange={(e) => setLink(kind, i, "url", e.target.value)} /></Field>
            <button onClick={() => delLink(kind, i)} className="text-red-500 hover:opacity-70 p-2"><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
    </Panel>
  );

  return (
    <div className="space-y-6">
      <Panel title="Footer Content" actions={<Button data-testid="save-footer" onClick={save} disabled={saving} className="rounded-xl bg-blue-600 hover:bg-blue-700 text-white"><Save size={14} className="mr-1" /> {saving ? "Saving..." : "Save"}</Button>}>
        <div className="grid md:grid-cols-2 gap-4">
          <Field label="Logo Text"><Input data-testid="footer-logo-text" value={data.logo_text || ""} onChange={(e) => set("logo_text", e.target.value)} /></Field>
          <Field label="Copyright"><Input value={data.copyright || ""} onChange={(e) => set("copyright", e.target.value)} /></Field>
          <Field label="Description" className="md:col-span-2"><Textarea rows={2} value={data.description || ""} onChange={(e) => set("description", e.target.value)} /></Field>
        </div>
      </Panel>
      <LinksBlock title="Quick Links" kind="quick_links" />
      <LinksBlock title="Legal Links" kind="legal_links" />
    </div>
  );
}
